<template>
    <div>
        <!-- <b-modal id="modal-to-items" @hide="fetch_init" scrollable title="TRANSFER ORDER" size="xl" hide-footer style="min-height: 700px;">
            <TransferOrderModal v-on:done-items-co="close_to_modal" style="min-height: 700px;" :viewdata="{id: transfer_order_id, products: products}" />
        </b-modal> -->

        <b-alert :show="show==true">
            <!-- <b-button size="sm" variant="success" @click="add_new_to">ADD NEW</b-button> -->
                <b-button size="sm" variant="primary" @click="fetch_init">
                    <span v-if="!first_load">LOAD ORDERS</span>
                    <span v-else>RELOAD</span>
                </b-button>
        </b-alert>

        <div v-if="first_load && items.length > 0">
        <b-card style="background: #f2f2f2; margin-bottom: 10px;">
            <b-card-text>
            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                <div style="width: 250px;">
                <div>ORDERING LOCATION</div>
                <b-form-select
                    :options="filterLocationOptions"
                    v-model="selectedLocation"
                ></b-form-select>
                </div>
                <div style="width: 250px;">
                <div>STATUS</div>
                <b-form-select
                    :options="filterStatusOptions"
                    v-model="selectedStatus"
                ></b-form-select>
                </div>
            </div>
            </b-card-text>
        </b-card>
        </div>
        <div v-if="items_being_loaded == true">
            <loading
                :active="true"
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>

        <div v-else>
            <div v-if="items_being_loaded == false">
                <div v-if="items.length == 0">
                    <div v-if="!first_load">
                    </div>
                    <div v-else>

                        <b-alert show variant="warning">NO TRANSFER ORDERS.</b-alert>
                    </div>
                </div>

                <div v-else>
                    <!-- <b-card style="margin-top: 5px;" v-for="item,idx in items" v-bind:key="idx">
                        {{item}}
                    </b-card> -->

                    <!-- Add this empty state for filtered results -->
                    <div v-if="(selectedLocation !== null || selectedStatus !== null) && displayItems.length === 0">
                        <b-alert show variant="info">No orders match the selected filters.</b-alert>
                    </div>

                    <table style="width: 100%;">
                        <thead>
                            <tr>
                                <td class="srr" style="width: 80px;" @click="sortby('id')">ORDER #</td>
                                <!-- <td class="srr" style="width: 200px;"  @click="sortby('ts')">CREATED AT</td> -->
                                <td class="srr" style="width: 150px;"  @click="sortby('created_by')">ORDERING USER</td>
                                <td class="srr" style="width: 200px;"  @click="sortby('ordering_location')">ORDERING LOCATION</td>
                                <td class="srr" style="width: 200px;"  @click="sortby('selling_locations')">SHIPPING LOCATION</td>
                                <td class="srr" style="width: 150px;"  @click="sortby('status')">STATUS</td>
                                <td class="srr" style="width: 150px;"  @click="sortby('requested_delivery_date')">REQ DEL DATE</td>
                                <td class="srr" style="width: 150px;"  @click="sortby('amount')" v-if="packet.userDetails.userrole === 'admin'">TOTAL</td>
                                <td class="srr" style="width: 150px;"  @click="sortby('paid')" v-if="packet.userDetails.userrole === 'admin'">PAID</td>
                                <td class="srr" style="width: 150px;"  @click="sortby('balance')" v-if="packet.userDetails.userrole === 'admin'">BALANCE</td>
                                <td class="srr" style="width: 100px;"  @click="sortby('n_products')"># ITEMS</td>

                                <!-- <td class="srr" style="width: 200px;"  @click="sortby('truck', packet.trucksdict)">TRUCK</td> -->

                                <!-- <td @click="sortby('approved')" class="srr" style="width: 200px;">ACTIONS</td> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item, idx in displayItems" v-bind:key="idx" :style="{background: ((item.approved) ? 'lightyellow': 'white')}">
                                <td class="srrv">{{item.id}}</td>
                                <!-- <td class="srrv">{{item.ts || get_current_time()}}</td> -->
                                <td class="srrv">{{item.created_by}}</td>
                                <td class="srrv">
                                    <b-form-select :options="locations" v-model="item.ordering_location" style="font-size: 14px;" :disabled="shouldDisableRow(item)"></b-form-select>
                                <input type="hidden" v-model="item.selling_location" />
                                </td>
                                <!-- <td class="srrv">
                                    <b-form-select :options="selling_locations" v-model="item.selling_location" style="font-size: 14px;" :disabled="shouldDisableRow(item)"></b-form-select>
                                </td> -->
                                <td class="srrv">
                                    <b-form-select 
                                        :options="selling_locations" 
                                        v-model="item.selling_location" 
                                        style="font-size: 14px;" 
                                        :disabled="shouldDisableRow(item)"
                                    ></b-form-select>
                                </td>
                                <!-- <td class="srrv">
                                    <input type="hidden" v-model="item.selling_location" /> VENANGO WH
                                </td> -->
                                <td class="srrv">
                                    <b-form-select :options="statuses" style="font-size: 14px;" v-model="item.status" :disabled="shouldDisableRow(item)"></b-form-select>
                                </td>
                                <td class="srrv">
                                    {{item.requested_delivery_date || "--"}}
                                </td>
                                <td class="srrv" v-if="packet.userDetails.userrole === 'admin'">
                                    {{ (parseFloat(item.amount) || 0.0).toFixed(2) }}
                                </td>
                                <td class="srrv" v-if="packet.userDetails.userrole === 'admin'">
                                    <span v-if="item.paid > 0" style="background: bisque; padding: 5px;">
                                        {{ (parseFloat(item.paid) || 0.0).toFixed(2) }}
                                    </span>
                                    <span v-else>
                                        {{ (parseFloat(item.paid) || 0.0).toFixed(2) }}
                                    </span>
                                </td>

                                <td class="srrv" v-if="packet.userDetails.userrole === 'admin'">
                                    <span v-if="item.balance > 0" style="background: lightyellow; padding: 5px;">
                                        {{ (parseFloat(item.balance) || 0.0).toFixed(2) }}
                                    </span>
                                    <span v-else>
                                        {{ (parseFloat(item.balance) || 0.0).toFixed(2) }}
                                    </span>
                                </td>
                                <td class="srrv">
                                    {{item.n_products}}
                                </td>

                                <!-- <td class="srrv">
                                    <b-form-select size="sm" :options="trucks" v-model="item.truck" :disabled="shouldDisableRow(item)" v-on:change="save_transfer_order(item)"></b-form-select>
                                </td> -->
                                <!-- <td class="srrv">

                                    <span v-if="item.loading">
                                        <loading
                                            :active="true"
                                            :can-cancel="false"
                                            :is-full-page="false">
                                        </loading>

                                    </span>
                                    <span v-else>
                                        <b-button
                                            size="sm"
                                            variant="outline-primary"
                                            @click="view_transfer_order(item)"
                                            v-b-tooltip.hover title="VIEW"
                                            v-if="(item.id) &&
                                                (
                                                    (item.ordering_location == packet.userDetails.properties.location_id && packet.userDetails.userrole == 'locationadmin' ) || (['admin', 'officemanager'].includes(packet.userDetails.userrole))
                                                )"
                                        >
                                            <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button size="sm" variant="outline-success" @click="save_transfer_order(item)" v-b-tooltip.hover title="SAVE" :disabled="shouldDisableRow(item)">
                                            <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button
                                            size="sm"
                                            @click="delete_transfer_order(item)"
                                            variant="outline-danger"
                                            v-if="item.username == item.created_by || ['admin', 'officemanager'].includes(packet.userDetails.userrole)"
                                            v-b-tooltip.hover title="DELETE"
                                        >
                                            <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                        </b-button>


                                        <b-button
                                            size="sm"
                                            @click="approve_transfer_order(item)"
                                            :variant="((item.approved) ? 'success' : 'outline-secondary')"
                                            v-if="['admin', 'officemanager'].includes(packet.userDetails.userrole)"
                                            v-b-tooltip.hover
                                            :title="((item.approved) ? 'APPROVED' : 'APPROVE')"
                                        >
                                            <b-icon icon="shield-check" aria-hidden="true"></b-icon>
                                        </b-button>
                                    </span>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-else>

            </div>
        </div>

    </div>
</template>
<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    //import TransferOrderModal from '@/components/TransferOrders/TransferOrderModal';

    export default {
        name: "ListCustomerOrders",
        props: [],
        components: {flatPickr, Loading, DatePicker}, //TransferOrderModal},
        data: function(){
            return {
                packet: {},
                show: true,
                first_load: null,
                items: [],
                items_being_loaded: null,
                transfer_order_id: null,
                products: [],
                locations: [],
                trucks: [],
                selectedLocation: null,
                selectedStatus: null,
                filteredItems: [],
                filterLocationOptions: [
                    { value: null, text: 'All Locations' },
                    // will be populated in created()
                ],
                filterStatusOptions: [
                    { value: null, text: 'All' },
                    // will be populated in created()
                ],
                // statuses: [
                //     {value: 1, text: "ORDERED"},
                //     {value: 2, text: "SCHEDULED"},
                //     {value: 3, text: "COMPLETED"},
                //     {value: 4, text: "ARCHIVED"},
                // ],
                sort_asc: true,

            }
        },
        methods: {
            applyFilters() {
                if (!Array.isArray(this.items)) {
                    this.filteredItems = [];
                    return;
                }

                // Reset filteredItems when no filters are active
                if (this.selectedLocation === null && this.selectedStatus === null) {
                    this.filteredItems = [];
                    return;
                }

                this.filteredItems = this.items.filter(item => {
                    if (!item) return false;

                    // Handle location filter - Vue 2 compatible version
                    const locationOption = this.filterLocationOptions.find(loc => loc.value === item.ordering_location);
                    const locationMatch = this.selectedLocation === null ||
                                    item.ordering_location === this.selectedLocation ||
                                    (locationOption && locationOption.text === this.selectedLocation);

                    // Handle status filter - Vue 2 compatible version
                    const statusOption = this.filterStatusOptions.find(stat => stat.value === item.status);
                    const statusMatch = this.selectedStatus === null ||
                                    item.status === this.selectedStatus ||
                                    (statusOption && statusOption.text === this.selectedStatus);

                    return locationMatch && statusMatch;
                });

                // Show message if no items match filters
                if (this.filteredItems.length === 0 && (this.selectedLocation !== null || this.selectedStatus !== null)) {
                    this.$bvToast.toast(
                        "No orders match the selected filters",
                        {title: "Filter Results", autoHideDelay: 2000, variant: "info"}
                    );
                }
            },
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            },
            // Checks if non-admin AND status is COMPLETED/ARCHIVED
            shouldDisableRow(item) {
                if (!item) return true; // disable if no item
                return !this.isAdmin() && [2,3, 4].includes(item.status);
            },
            approve_transfer_order: function(item){
                if (item.approved){
                    return
                }
                let path = "/api/sales/approve_transfer_order/"
                let data = {"id": item.id, "approved": true}
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR APPROVING TRANSFER ORDER.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "SUCCESS APPROVING TRANSFER ORDER.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        if (response.data.result.length > 0){
                            let approved = response.data.result[0]["approved"];
                            item.approved = approved;
                        }

                    }
                    item.loading = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH APPROVING TRANSFER ORDER. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading = false;
                }
                item.loading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },

            save_transfer_order: function(item){
                // Ensure selling_location is always set to Venango WH
                if (this.selling_locations.length > 0 && !item.selling_location) {
                    item.selling_location = this.selling_locations[0].value;
                }
                let data = item;
                let path = "/api/sales/record_transfer_order/"
                if (item.id){
                    path = "/api/sales/update_transfer_order/"
                }
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR SAVING TRANSFER ORDER.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        if (response.data.result.length > 0){
                            let id = response.data.result[0].id;
                            item.id = id;
                        }

                    }
                    item.loading = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH SAVING TRANSFER ORDER. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.loading = false;
                }
                item.loading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            get_current_time: function(){
                return moment().format("MM-DD-YYYY hh:mm:ss")
            },
            fetch_init: function(){
                let data = {}
                let path = "/api/sales/get_transfer_orders/"
                if (this.packet.userDetails.properties.location_id){
                    data.location_id = parseInt(this.packet.userDetails.properties.location_id);
                }
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING TRANSFER ORDERS.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        console.log('this.packet.userDetails.properties.location_id',that.packet.userDetails.properties.location_id)
                        console.log('response.data.result',response.data.result)
                        const userLocationId = that.packet.userDetails.properties.location_id;
                        console.log('userLocationId',userLocationId)
                        // that.items = response.data.result || []; // Ensure items is always an array
                        that.items = (response.data.result || []).filter(d => d.ordering_location === Number(userLocationId));
                        that.first_load = true;
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH TRANSFER ORDERS. TRY AGAIN LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            // fetch_prereqs: function(){
            //     let data = {}
            //     let path = "/api/product/get_product_list_v5/"
            //     let that = this;
            //     let s = function(response) {
            //         if (response.data.error){
            //             that.$bvToast.toast(
            //                 "ERROR RETRIEVING PRODUCT LIST",
            //                 {title: "Error", autoHideDelay: 1500, variant:"warning"}
            //             );
            //         }
            //         else {
            //             that.products = response.data.result;
            //             //console.log(that.products)
            //             //that.fetch_init();
            //             that.show = true;
            //         }
            //         //that.items_being_loaded = false;
            //     }

            //     let f = function(error) {
            //         that.$bvToast.toast(
            //             "Error retrieving products.",
            //             {title: "Error", autoHideDelay: 1500, variant:"danger"}
            //         );
            //         //that.items_being_loaded = false;
            //     }
            //     //this.items_being_loaded = true;
            //     Requestor.getAsyncP(path, data, this, s, f);
            // },
            add_new_to: function(){

                if (this.items.filter(function(d){return !(d.id) }).length > 0){
                    this.$vex.dialog.alert(
                        {message: "PLEASE SAVE THE EXISTING NEW ORDER FIRST."}
                    );
                    return
                }

                let item = {
                    id: null,
                    created_by: this.packet.userDetails.username,
                    ordering_location: null,
                    selling_location: null,
                    status: null,
                    comments: null,

                }
                this.items.splice(0, 0, item);
            },
            delete_transfer_order: function(item){
                if (!item.id){
                    this.items = this.items.filter(function(d){return d.id})
                }
                else {
                    let path = "/api/sales/delete_transfer_order/"
                    let data = {id: item.id}
                    let that = this;

                    let s = function(response) {
                        if (response.data.error){
                            that.$bvToast.toast(
                                "ERROR DELETING TRANSFER ORDER",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            that.$bvToast.toast(
                                "DELETED TRANSFER ORDER",
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                            //that.items = that.items.filter(function(d){return d.id != item.id})

                            //console.log(that.products)
                            that.fetch_init();
                        }
                        that.items_being_loaded = false;
                    }

                    let f = function(error) {
                        that.$bvToast.toast(
                            "ERROR OCCURRED.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }
                    this.items_being_loaded = true;
                    Requestor.postSyncP(path, data, this, s, f);
                }
            },
            view_transfer_order: function(item){
                this.show_to_modal(item)
            },
            show_to_modal: function(item){
                if (!item){
                    this.transfer_order_id  = null;
                }
                else {
                    this.transfer_order_id = item.id;
                }
                //console.log(this.transfer_order_id, this.products)
                this.$bvModal.show("modal-to-items");
            },
            close_to_modal: function(){
                this.$bvModal.hide("modal-to-items");
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
        },
        computed: {
            displayItems() {
                // If we have active filters and filteredItems is empty, return empty array
                if ((this.selectedLocation !== null || this.selectedStatus !== null) &&
                    this.filteredItems.length === 0) {
                    return [];
                }

                // Otherwise return filtered items or all items
                return this.filteredItems.length > 0 ?
                    this.filteredItems.filter(item => item != null) :
                    (this.items || []).filter(item => item != null);
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            console.log(this.packet.userDetails);

            // Status options
            this.allStatuses = [
                {value: 1, text: "ORDERED"},
                {value: 2, text: "SCHEDULED"},
                {value: 3, text: "COMPLETED"},
                {value: 4, text: "ARCHIVED"},
            ];

            this.filterStatusOptions = [
                { value: null, text: 'All' },
                ...this.allStatuses
            ];

            this.statuses = this.allStatuses.map(status => {
                if (this.packet.userDetails.userrole !== 'admin') {
                    return {
                        ...status,
                        disabled: ['SCHEDULED','COMPLETED', 'ARCHIVED'].includes(status.text)
                    };
                }
                return status;
            });

            // Get all locations (excluding 'All') first
            let allLocations = this.packet.locations.filter(function(d) { return d.text != 'All' });

            // Initialize filter location options
            this.filterLocationOptions = [
                { value: null, text: 'All Locations' },
                ...allLocations.map(loc => ({
                    value: loc.value, // Make sure this matches item.ordering_location
                    text: loc.text
                }))
            ];

            // Filter locations based on user role
            if (this.packet.userDetails.userrole !== 'admin') {
                // For non-admin users, show only their location
                const userLocationId = this.packet.userDetails.properties.location_id;
                this.locations = allLocations.filter(function(d) {
                    return d.value == userLocationId;
                });
            } else {
                // For admin users, show all locations
                this.locations = allLocations;
            }

            // old concept
            // this.selling_locations = this.packet.locations.filter(function(d) {
            //     return d.text.toLowerCase().includes('venango wh');
            // });

            this.selling_locations = this.packet.locations.filter(function(d) { 
                return d.text != 'All' 
            });

            // Automatically set selling_location to Venango WH for all items // OLD concept
            // if (this.selling_locations.length > 0) {
            //     const venangoId = this.selling_locations[0].value;
            //     this.items = this.items.map(item => {
            //         return {
            //             ...item,
            //             selling_location: venangoId
            //         };
            //     });
            // }

            this.trucks = this.packet.housetrucks.filter(function(d) { return d.text != "" });
            //this.fetch_prereqs();
        },
        // created: function(){
        //     this.packet = JSON.parse(localStorage.packet);
        //     //this.packet.vendors.splice(0, 0, {value: null, text: "ALL"});
        //     this.packet.userDetails = JSON.parse(localStorage.userDetails);
        //     this.locations = this.packet.locations.filter(function(d){return d.text != 'All'});
        //     this.selling_locations = this.packet.locations.filter(function(d){return d.text.toLowerCase().includes('venango wh')});

        //     this.trucks = this.packet.housetrucks.filter(function(d){return d.text != ""});
        //     this.fetch_prereqs();
        // }
    }
</script>


<style scoped>
    .srr {
        font-size: 14px;
        text-align: center;
        background: #ffeaa7;
        border: 1px solid #010101;
        font-weight: bold;
    }

    .srrv {
        font-size: 14px;
        text-align: center;

        border: 1px solid #010101;
        padding: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/TransferOrders/RecievingTransferOrder.vue